module.exports = __webpack_public_path__ + "img/generation-logo.d42a1cad.png";